// @flow
// Libs
import { combineReducers } from 'redux'
import createStore from 'fc-store'

// Middleware
import { createLogger } from 'redux-logger'
import { routerMiddleware, routerReducer as router } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import leafletMiddleware from 'fc-redux-leaflet'

// Reducers
import auth from 'hfty-reducers/auth'
import userData from 'hfty-users/src/reducers'
import assetData from 'hfty-assets/src/reducers'
import soilJobData from 'hfty-soil-jobs/src/reducers'
import seasonData from 'fc-seasons/src/reducers'
import assetsModule from 'hfty-assets-dom/src/reducers'
import suppliesData from 'hfty-supplies/src/reducers'
import soilJobsModule from 'hfty-soil-jobs-dom/src/reducers'
import commentsModule from 'hfty-comments-dom/src/reducers'
import commentsData from 'hfty-comments/src/reducers'
import navigation from 'hfty-navigation-web/src/reducers'
import accountsModule from 'hfty-accounts/src/reducers'
import usersModule from 'hfty-users-dom/src/reducers'
import soilTestResultData from 'fc-soil-test-results/src/reducers'
import locale from 'data/locale'
import { mapReducers as mapModule } from 'hfty-map'
import environmentData from 'fc-environment/src/reducers'
import { contactUsReducers as contactUsModule } from 'hfty-contact-us'
import { requestInfoReducers as requestInfos } from 'fc-requests'
import { reducers as ordersData } from 'hfty-orders'
import { reducers as ordersModule } from 'hfty-order-supplies-dom'
import { reducers as assetMigrateModule } from 'hfty-asset-migrate-dom'
import { reducers as reportsData } from 'hfty-reports-dom'
import { reducers as recommendationsData } from 'hfty-recommendations'
import { reducers as recommendationsModule } from 'hfty-recommendations-dom'
import { reducers as cropData } from 'fc-model-crops'
import {
  reducers as fertilizersData,
  operationsReducers as fertilizersModule,
} from 'hfty-fertilizers'
import { reducers as layerData } from 'hfty-layers'
// Initial State
import preloadedState from './initialState'

// Sagas
import rootSaga from './sagas'

// History
export const history = createHistory()

const reducer = combineReducers({
  auth,
  assetData,
  assetsModule,
  assetMigrateModule,
  suppliesData,
  navigation,
  router,
  seasonData,
  soilJobData,
  soilJobsModule,
  commentsModule,
  commentsData,
  userData,
  accountsModule,
  environmentData,
  mapModule,
  usersModule,
  reportsData,
  ordersData,
  ordersModule,
  contactUsModule,
  locale,
  requestInfos,
  cropData,
  recommendationsData,
  recommendationsModule,
  soilTestResultData,
  fertilizersData,
  fertilizersModule,
  layerData,
})

const store = createStore({
  preloadedState,
  reducer,
  middleware: __DEV__ ? [
    createLogger(),
    leafletMiddleware,
    routerMiddleware(history),
  ] : [
    leafletMiddleware,
    routerMiddleware(history),
  ],
})

store.runSaga(rootSaga)

window._store = store
window.turf = require('@turf/union')
export default store
